import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { map, take, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

// Functional route guard for protected routes
export const authGuard: CanActivateFn = (route, state) => {
  // Bypass authentication in development mode
  if (environment.skipAuth) {
    console.log('[DEV MODE] Authentication bypassed');
    return of(true);
  }

  const oidcSecurityService = inject(OidcSecurityService);
  const authService = inject(AuthService);

  console.log('[AuthGuard] Checking authentication...');

  return oidcSecurityService.isAuthenticated$.pipe(
    take(1),
    map(({ isAuthenticated }) => {
      console.log('[AuthGuard] isAuthenticated:', isAuthenticated);

      if (isAuthenticated) {
        console.log('[AuthGuard] User is authenticated, allowing access');
        return true;
      }

      // Log in and come back to the attempted URL (deep links included)
      console.log('[AuthGuard] User not authenticated, starting login for', state.url);
      authService.login(state.url);
      return false;
    })
  );
};

// Guard that allows access only if NOT authenticated (e.g., for login page)
export const noAuthGuard: CanActivateFn = (route, state) => {
  const oidcSecurityService = inject(OidcSecurityService);
  const router = inject(Router);

  return oidcSecurityService.isAuthenticated$.pipe(
    take(1),
    map(({ isAuthenticated }) => {
      if (!isAuthenticated) {
        return true;
      }

      // Already authenticated, redirect to home
      router.navigate(['/']);
      return false;
    })
  );
};
